/* 
 References:
 https://developer.mozilla.org/en-US/docs/Web/API/WebRTC_Statistics_API
 https://stackoverflow.com/questions/63152869/detect-if-mediastreamtrack-is-black-blank
*/

export default class GetConnectionStats {

  constructor(peer){
    this.peer = peer;
    this.previousBytesSent = {};
    this.previousBytesRcvd = {};
    this.previousTimeStamp = Date.now(); // in milli seconds from 1970
    this.currentTimeStamp = Date.now();
    this.getStats = this.getStats.bind(this);
  }

  async getStats() {

    let retStr = "";

    try {
      const stats = await this.peer.getStats(null); 

      stats.forEach (report => {
        this.currentTimeStamp = report.timestamp;
        const id = report.id.toString();

        if (report.type === 'outbound-rtp'){
          const currentBytesSent = report.bytesSent;

          if (this.previousBytesSent[id] === undefined)
                 this.previousBytesSent[id] = 0;

           const prev = this.previousBytesSent[id];
           const outbps = (currentBytesSent - prev)*8
               / (this.currentTimeStamp - this.previousTimeStamp);

           this.previousBytesSent[id] = currentBytesSent;

           retStr += `TimeStamp(ms): ${this.currentTimeStamp}, `
                + `SSRC: ${report.ssrc.toString(16)}, `
                + `kind: ${report.kind}, `
                + `outbps(kbps): ${outbps.toFixed(2)}\n`; 

         } // end outbound 

         if (report.type === 'inbound-rtp'){
           const currentBytesRcvd = report.bytesRecvd;

           if (this.previousBytesRcvd[id] === undefined)
               this.previousBytesRcvd[id] = 0;

           const prev = this.previousBytesRcvd[id];
           const inbps = (currentBytesRcvd - prev)*8
               / (this.currentTimeStamp - this.previousTimeStamp);

           this.previousBytesRcvd[id] = currentBytesRcvd;

           retStr += `TimeStamp(ms): ${this.currentTimeStamp}, `
                  + `SSRC: ${report.ssrc.toString(16)}, `
                  + `MediaType: ${report.mediaType}, `
                  + `inbps(kbps): ${inbps.toFixed(2)}\n`; 

         } // end inbound

       }); // forEach

     } catch (e) { console.error(e);}


    this.previousTimeStamp = this.currentTimeStamp;  

    return retStr;
  } // end getStats()

};
